<template>
  <b-card>
    <div
      v-for="j in Array(total).fill().map((v, i) => i)"
      :key="j"
    >
      <div class="animated-text-line header" />
      <div
        v-for="i in new Array(10)"
        :key="i"
        class=" row"
      >
        <div class="col-md-4">
          <div class="animated-text-line" />
        </div>
        <div class="col-md-8">
          <div class="animated-text-line" />
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'LineLoader',
  props: {
    size: {
      type: Number
    }
  },
  computed: {
    total () {
      return this.size || 2
    }
  }
}
</script>

<style scoped lang='scss'>
.animated-text-line {
  height: 1rem;
  width: 98%;
  margin-bottom: 1rem;
}
.animated-text-line.header {
  width: 25rem;
  height: 1.5rem;
  margin: 2rem 0;
}
</style>
